import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

import { Automation, ManualAutomationTrigger } from 'src/models';
import { AuthService } from 'src/services/auth.service';
import { AutomationsService } from 'src/services/automations.service';
import { MessageService } from 'src/services/message.service';

@Component({
  selector: 'app-trigger-manual-automation-modal',
  templateUrl: './trigger-manual-automation-modal.component.html',
  styleUrls: ['./trigger-manual-automation-modal.component.scss'],
})
export class TriggerManualAutomationModalComponent implements OnInit {
  @ViewChild('nameInput', { static: false }) nameInput;

  isLoading = false;
  id: string;
  inputFields: any[] = [];
  conversationId: string;
  automation: Automation;

  constructor(
    navParams: NavParams,
    public authService: AuthService,
    private modalCtrl: ModalController,
    private msgSrvc: MessageService,
    private automationsService: AutomationsService,
  ) {
    this.id = navParams.get('id');
    this.automation = navParams.get('automation');
  }

  async ngOnInit() {
    if (!this.automation) {
      await this.loadAutomation();
    }

    this.inputFields = [...((this.automation?.trigger as ManualAutomationTrigger).data.inputFields ?? [])];
  }

  async loadAutomation() {
    this.isLoading = true;

    try {
      const automation = await this.automationsService.getById(this.id);
      this.automation = automation;
    } catch (error) {
      await this.msgSrvc.showError(error);
    } finally {
      this.isLoading = false;
    }
  }

  async submit() {
    this.isLoading = true;

    try {
      await this.automationsService.runAutomationForConversation(
        this.id,
        this.conversationId,
        this.inputFields.reduce((acc, field) => {
          acc[field.id] = field.value ?? undefined;

          return acc;
        }, {}),
      );

      await this.msgSrvc.show('✔︎ Automation triggered');

      this.dismiss();
    } catch (error) {
      await this.msgSrvc.showError(error);
    } finally {
      this.isLoading = false;
    }
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
